import EcsContact from './EcsContact';
import { CONTACT_TYPE } from '@/constants/contactConstants';

export default class EcsEnterpriseContact extends EcsContact {
  get contactType() {
    return CONTACT_TYPE.enterprise;
  }

  get isEnterpriseContact() {
    return true;
  }

  get isInternalContact() {
    return true;
  }

  get state() {
    return this.stateDisplayName;
  }

  get company() {
    return this.department;
  }

  get phones() {
    if (!this.broadsoftIdentifer) {
      return [];
    }

    const phonesList = [
      {
        description: 'HPBX Address',
        value: this.broadsoftIdentifer
      }
    ];

    if (this['Mobile Phone']) {
      phonesList.push({
        description: 'Mobile Phone',
        value: this['Mobile Phone']
      });
    }

    return phonesList;
  }

  get endPoint() {
    return this.phones.length ? this.phones[0].value : null;
  }
}
